module.exports = __webpack_public_path__ + "img/member_shopping_online_icon_431005.6b0c7d6f.png";